import { functions } from '../../config/firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * Generate narration audio for `text`. When `target` names a book element
 * ({ bookId, spreadId, elementId }) the callable also writes the audio onto
 * that element server-side, so the result survives a closed tab.
 */
export async function generateTextAudio(text, target = {}) {
  const callable = httpsCallable(functions, 'generateTextAudio');
  const data = { text };
  if (target.bookId && target.spreadId && target.elementId) {
    data.bookId = target.bookId;
    data.spreadId = target.spreadId;
    data.elementId = target.elementId;
  }
  const resp = await callable(data);
  return (resp && resp.data) || {};
}
